import React from 'react';
import ReactDOM from 'react-dom/client';

import App from './App';
import reportWebVitals from './reportWebVitals';
import { loadConfig } from './helpers/config';
import { registerServiceWorker } from './helpers/notifications';


const root = ReactDOM.createRoot(document.getElementById('root'));

async function startApp() {
  try {
    await loadConfig();
    root.render(
      <React.StrictMode>
        <App />
      </React.StrictMode>
    );

    // Register service worker for PWA and push notifications
    if (process.env.NODE_ENV === 'production') {
      registerServiceWorker();
    }
  } catch (e) {
    root.render(
      <div style={{ fontFamily: 'sans-serif', padding: '2rem', color: '#b91c1c' }}>
        <h2>Configuration Error</h2>
        <p>{e.message}</p>
      </div>
    );
  }
}

startApp();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
